<template>
    <pendo-multiselect
        class="custom-search-resource-select"
        :class="`${field}-select`"
        :value="value"
        :options="filteredOptions"
        :extra-label-width="120"
        :allow-empty="false"
        :append-to-body="false"
        :value-key="valueKey"
        :loading="loading"
        sort-by="name"
        :disabled="readOnly"
        :popup-type="popupType"
        full-width
        :searchable="true"
        label-key="name"
        :placeholder="placeholder"
        :invalid="checkValidRule && !valid"
        @select="onOptionSelect"
        @input-value-change="handleSearch">
        <template
            v-if="$slots.header"
            #header="{ toggleMenu, model }">
            <slot
                name="header"
                v-bind="{
                    toggleMenu,
                    model,
                }" />
        </template>

        <template
            v-if="$slots.selectedLabel"
            #selectedLabel="{ option }">
            <slot
                name="selectedLabel"
                v-bind="{
                    option,
                }" />
        </template>
        <template #option="{ option, index }">
            <slot
                name="option"
                v-bind="{ option, index }">
                <div class="option-wrapper">
                    <pendo-guide-status-option
                        v-if="option.state"
                        tooltip
                        :option="sanitizeOption(option)" />
                    <template v-else>
                        <ellipsis-tooltip-text :text="option.name" />
                    </template>
                </div>
            </slot>
        </template>

        <template #noData>
            <slot name="noData" />
        </template>
    </pendo-multiselect>
</template>

<script>
import { PendoGuideStatusOption, PendoMultiselect } from '@pendo/components';
import { sanitizeState } from '@pendo/services/Formatters';
import cloneDeep from 'lodash/cloneDeep';
import EllipsisTooltipText from '@/common/ellipsis-tooltip-text/ellipsis-tooltip-text.vue';

export default {
    name: 'CustomSearchResourceSelect',
    components: {
        PendoMultiselect,
        PendoGuideStatusOption,
        EllipsisTooltipText,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        field: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Select Option',
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        customFilter: {
            type: Function,
            required: true,
        },
        popupType: {
            type: String,
            default: 'listbox',
        },
    },
    emits: ['input'],
    data () {
        return {
            filteredResource: [],
        };
    },
    computed: {
        valid () {
            return this.value != null && this.value !== false;
        },
        valueKey () {
            return this.field;
        },
        filteredOptions () {
            return this.filteredResource;
        },
    },
    watch: {
        options () {
            this.filteredResource = this.options;
        },
    },
    created () {
        this.filteredResource = this.options;
    },
    methods: {
        onOptionSelect (option) {
            this.$emit('input', { field: this.field, value: option });
        },
        handleSearch (query) {
            if (query.length === 0) {
                this.filteredResource = this.options;
            } else {
                this.filteredResource = this.customFilter({ query, options: cloneDeep(this.options) });
            }
        },
        sanitizeOption (option) {
            return sanitizeState(option);
        },
    },
};
</script>

<style lang="less" scoped>
.option-wrapper {
    display: flex;
    align-items: center;
    line-height: 18px;
}
</style>
